var _defs, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.4 154.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9e5f4;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #39b54a;\n      }\n\n      .cls-4 {\n        fill: #ebf2f9;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9.29,
    y: 27.32,
    width: 143.09,
    height: 118.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.27,111.76c0,4.22-18.55,7.64-41.44,7.64s-41.44-3.42-41.44-7.64,18.55-7.65,41.44-7.65,41.44,3.42,41.44,7.65Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.44,22.33l-34.61-11.61-34.27,11.45c-4.37,1.93-8.21,3.09-8.21,6.89v18.96c0,13.16,3.69,26.21,11.29,37.72,6.39,9.69,16.29,19.67,31.53,26.01,14.01-4.25,24.47-15.58,30.86-25.27,7.6-11.52,11.29-24.56,11.29-37.72v-17.05c0-5.43-3.08-8.08-7.88-9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.1,104.3l-.14-.06c-11.42-4.75-20.64-12.36-27.4-22.61-6.42-9.73-9.81-21.07-9.81-32.79v-16.35c0-3.2,2.83-4.41,6.1-5.81.41-.17.83-.35,1.25-.54l29.75-9.94,29.99,10.06c4.78,1.3,7.11,4.09,7.11,8.52v14.71c0,11.72-3.39,23.06-9.81,32.79-4.26,6.46-13.42,17.9-26.86,21.98l-.15.05ZM80.83,17.12l-29.43,9.83c-.39.17-.81.35-1.22.53-3.11,1.33-5.57,2.38-5.57,5v16.35c0,11.55,3.34,22.72,9.67,32.31,6.63,10.05,15.67,17.53,26.86,22.22,13.1-4.04,22.06-15.24,26.24-21.58,6.33-9.59,9.67-20.76,9.67-32.31v-14.71c0-4.03-2.06-6.47-6.47-7.68h-.02s-29.72-9.98-29.72-9.98Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.7 76.09 58.16 59.75 63.86 52.93 76.96 63.89 97.03 42.53 103.51 48.61 77.7 76.09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyGraphic);
export default __webpack_public_path__ + "static/media/safety_graphic.7435f5f25c408e53d5995d60c962a374.svg";
export { ForwardRef as ReactComponent };